import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { EVENT_TYPES } from '../constants/eventTypes';

const PEOPLE_OPTIONS = [
  { id: 'RESPONDED', label: 'Whoever responded', hint: 'Invite people who voted' },
  { id: 'ALL', label: 'All participants', hint: 'Invite everyone from this poll' },
  { id: 'NOT_RESPONDED', label: 'Whoever did not respond', hint: 'Invite people who have not voted' },
];

const FollowUpEventPrompt = ({
  isOpen,
  onClose,
  onSelectType,
  onContinue,
  title = 'Create another event?',
  description = 'Do you want to create another event, like expense sharing or a calculation?',
  includePoll = true,
  askParticipants = false,
}) => {
  const [step, setStep] = useState('type');
  const [eventType, setEventType] = useState('');
  const types = includePoll ? EVENT_TYPES : EVENT_TYPES.filter((type) => type.id !== 'POLL');

  useEffect(() => {
    if (isOpen) {
      setStep('type');
      setEventType('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const pickType = (typeId) => {
    if (askParticipants) {
      setEventType(typeId);
      setStep('people');
      return;
    }
    onSelectType?.(typeId);
    onContinue?.({ eventType: typeId });
  };

  const pickPeople = (participantMode) => {
    onContinue?.({ eventType, participantMode });
  };

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[1400] overflow-y-auto">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative w-full max-w-md rounded-2xl bg-white dark:bg-gray-900 shadow-xl border border-gray-200 dark:border-gray-700">
          <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {step === 'people' ? 'Who should be invited?' : title}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {step === 'people'
                ? 'Choose who from this poll should join the new event.'
                : description}
            </p>
          </div>
          {step === 'type' ? (
            <div className="p-4 grid grid-cols-2 gap-2">
              {types.map((type) => (
                <button
                  key={type.id}
                  type="button"
                  onClick={() => pickType(type.id)}
                  className="text-left rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2.5 hover:border-primary-400 hover:bg-primary-50/60 dark:hover:bg-primary-950/20"
                >
                  <span className="text-lg">{type.icon}</span>
                  <p className="text-sm font-semibold text-gray-900 dark:text-white mt-1">{type.label}</p>
                </button>
              ))}
            </div>
          ) : (
            <div className="p-4 space-y-2">
              {PEOPLE_OPTIONS.map((option) => (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => pickPeople(option.id)}
                  className="w-full text-left rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2.5 hover:border-primary-400 hover:bg-primary-50/60 dark:hover:bg-primary-950/20"
                >
                  <p className="text-sm font-semibold text-gray-900 dark:text-white">{option.label}</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{option.hint}</p>
                </button>
              ))}
            </div>
          )}
          <div className="px-5 py-3 border-t border-gray-200 dark:border-gray-700 flex justify-between">
            {step === 'people' ? (
              <button
                type="button"
                onClick={() => setStep('type')}
                className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200"
              >
                Back
              </button>
            ) : (
              <span />
            )}
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200"
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default FollowUpEventPrompt;
